import { CheckBoxRememberMe } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { model as signInModel } from '~/features/subscriber/sign-in'
import { translations } from '../sign-in-by-email/model'

export const RememberMe = () => {
  const formTranslations = useUnit(translations.$signInByEmailTranslations)
  const rememberMe = useUnit(signInModel.$rememberMe)
  const onChangeRememberMe = useUnit(signInModel.toggleRememberMe)

  return (
    <CheckBoxRememberMe
      label={formTranslations.rememberMe}
      checked={rememberMe}
      onChange={onChangeRememberMe}
    />
  )
}
